var $50e77a8887ec2ed1$exports = {};
$50e77a8887ec2ed1$exports = {
    "maximum": `Massimo`,
    "minimum": `Minimo`
};


export {$50e77a8887ec2ed1$exports as default};
//# sourceMappingURL=it-IT.module.js.map
